import { usePlanwerte } from '@/domain/controlling/hooks';
import { MonthParams } from '../../types';
import { useParams } from 'react-router-dom';
import { Abweichung, ZielstundenField } from '../../components';
import { useTranslation } from 'react-i18next';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/pro-solid-svg-icons';
import { useUmsatzplanungSollstunden } from '@/domain/controlling/hooks/useUmsatzplanungSollstunden';
import { useStandortContext } from '@/features/standortContext/StandortContext';

export function SollstundenAbweichungKPI({
  type,
}: {
  type: 'absatz' | 'umsatz';
}) {
  const {
    currentStandort: { id: standortId },
  } = useStandortContext();
  const { year, month } = useParams<MonthParams>();
  const { t } = useTranslation();
  const { sollstunden: zielSollstunden } = useUmsatzplanungSollstunden(
    standortId,
    {
      jahr: parseInt(year),
      monat: parseInt(month),
    },
  );

  const { planwerte } = usePlanwerte({
    standortId,
    jahrMonat: { jahr: parseInt(year), monat: parseInt(month) },
  });

  let sollstundenSum = 0;
  if (type == 'umsatz') {
    planwerte.forEach((planwert) => {
      if (planwert.umsatzPlan.umsatz) {
        sollstundenSum = planwert.umsatzPlan.umsatz.stunden + sollstundenSum;
      }
    });
  } else {
    planwerte.forEach((planwert) => {
      if (planwert.absatzPlan.absatz) {
        sollstundenSum = planwert.absatzPlan.absatz.stunden + sollstundenSum;
      }
    });
  }

  return (
    <div className="flex flex-col gap-2 w-1/3">
      <div className="flex gap-2 items-center">
        <FontAwesomeIcon
          icon={faCircle}
          className="text-primary-blue-600 h-3 w-3"
        />
        <div className="text-xs font-semibold text-neutrals-700">
          {t('domain.controlling.umsatzplanung.table.zielstunden')}
        </div>
      </div>
      <div className="flex flex-col gap-1">
        <ZielstundenField
          value={sollstundenSum}
          className="[&>div:nth-child(odd)]:text-2xl [&>div:nth-child(even)]:text-base [&>div:nth-child(odd)]:font-extrabold [&>div:nth-child(even)]:font-normal"
        />
        <Abweichung
          tooltipMessage={t(
            'domain.controlling.umsatzplanung.planung.tooltip.abweichungZuSollstunden',
          )}
          baseValue={sollstundenSum}
          comparisonValue={
            zielSollstunden.aushilfen + zielSollstunden.festangestellte
          }
          type="stunden"
          unit={t('general.currency.EUR')}
        />
      </div>
    </div>
  );
}
